import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

const useUserPrivilegesApi = () => {
  const getGrantedPrivileges = useCallback(async (userId) => {
    const response = await axiosInstance.get(`/api/users-priviliges/${userId}`);
    return response.data;
  }, []);

  const updateUserPrivileges = useCallback(async (userId, privileges) => {
    const response = await axiosInstance.put('/api/users-priviliges/', {
      userId,
      privileges,
    });
    return response.data;
  }, []);

  const hasCustomPrivileges = useCallback(async (userId) => {
    const response = await axiosInstance.get(
      `/api/users-priviliges/${userId}/has-custom`
    );
    return response.data.hasCustomPrivileges;
  }, []);

  return { getGrantedPrivileges, updateUserPrivileges, hasCustomPrivileges };
};

export default useUserPrivilegesApi;
